// @Packages
import React from 'react';
import { View } from 'react-native';

// @styles
import ListItemComponent from '../list-item';
import useStyles from './styles';

interface Props {
  items: Record<string, any>[];
  onPress: (item: Record<string, any>) => void;
  titleProp: string;
  idProp: string;
  statusProp: string;
}

const List = ({
  items,
  statusProp,
  titleProp,
  idProp,
  onPress
}: Props) => {
  const style = useStyles();

  return (
    <View style={style.mainContainer}>
      {items.map((item) => (
        <ListItemComponent
          key={item[idProp]}
          title={item[titleProp]}
          session={item[statusProp]}
          onPress={() => onPress(item)}
        />
      ))}
    </View>
  );
};

export default List;
